import type { SVGProps } from 'react';

export const Chevron = (props: SVGProps<any>) => (
  <svg
    height="12px"
    role="img"
    viewBox="0 0 22 12"
    width="22px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'chevron'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-5.000000, -10.000000)">
        <rect height="32" width="32" x="0" y="0" />
        <g
          fill={props.fill}
          fillRule="nonzero"
          transform="translate(16.000000, 16.000000) scale(1, -1) translate(-16.000000, -16.000000) translate(5.000000, 10.000000)"
        >
          <path
            d="M15.7859425,17 C16.4760383,17 17,16.4549849 17,15.7371601 C17,15.3915408 16.8722045,15.0725076 16.6421725,14.8332326 L7.96485623,6.00664653 L16.6421725,-2.83323263 C16.8722045,-3.07250755 17,-3.39154079 17,-3.73716012 C17,-4.44169184 16.4760383,-5 15.7859425,-5 C15.4536741,-5 15.1597444,-4.86706949 14.9297125,-4.62779456 L5.40894569,5.04954683 C5.15335463,5.3021148 5.01277955,5.64773414 5,6.00664653 C5,6.36555891 5.14057508,6.68459215 5.40894569,6.95045317 L14.9297125,16.6277946 C15.1597444,16.8670695 15.4536741,17 15.7859425,17 Z"
            transform="translate(11.000000, 6.000000) rotate(-90.000000) translate(-11.000000, -6.000000) "
          />
        </g>
      </g>
    </g>
  </svg>
);
